import { render } from "./FeedbackTab.vue?vue&type=template&id=5db907e2"
import script from "./FeedbackTab.vue?vue&type=script&lang=js"
export * from "./FeedbackTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__